import { Turbo } from "@hotwired/turbo-rails";
import Sortable from "sortablejs";

function initSortable() {
  const el = document.getElementById("sortable-target");
  if (el) {
    Sortable.create(el, {
      animation: 200,
      chosenClass: "sortable-chosen",
      handle: ".sortable-handle",

      async onEnd(event) {
        // APIの二重呼び出しを防ぐため、ドラッグ完了の時点でSortableを終了します。
        Sortable.get(event.target).destroy();

        let referenceElement = null;

        if (event.newIndex < event.oldIndex) {
          // 上に移動
          referenceElement = event.item.nextElementSibling;
        } else if (event.newIndex > event.oldIndex) {
          // 下に移動
          referenceElement = event.item.previousElementSibling;
        }

        if (referenceElement !== null) {
          const newPosition = referenceElement.dataset.position;
          const csrfToken = document.querySelector(
            "meta[name=csrf-token]",
          ).content;

          await fetch(`/v2/topics/${event.item.dataset.id}/position`, {
            method: "PUT",
            headers: {
              "X-CSRF-Token": csrfToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ newPosition }),
          });
        }
        /**
         * 同じ画面を複数のユーザが同時に操作している可能性があるため、
         * API呼び出しの可否にかかわらず画面を更新します。
         * 画面の更新により、新しい Sortable も起動します。
         */
        Turbo.visit(document.location, { frame: "topic-list" });
      },
    });
  }
}
document.addEventListener("turbo:frame-load", initSortable);
document.addEventListener("turbo:load", initSortable);
